import React, { FC, useRef } from 'react';

import { PlayerView } from '../../player-view/component';

import styles from './FilmPlayerView.module.css';
import { FilmPlayerSkin } from './FilmPlayerSkin';

interface FilmPlayerViewProps {
    contentId: string;
    onClose?: () => void;
}

export const FilmPlayerView: FC<FilmPlayerViewProps> = ({ onClose, contentId }) => {
    const containerRef = useRef<HTMLDivElement>(null);

    return (
        <div ref={containerRef}>
            <PlayerView className={styles.root}>
                <FilmPlayerSkin
                    contentId={contentId}
                    className={styles.skin}
                    onClose={onClose}
                    rootContainerRef={containerRef}
                />
            </PlayerView>
        </div>
    );
};
